import React from 'react'
import { useTranslation } from 'react-i18next'
import moment from 'moment'
import { durationToMinutes, minutesToHours } from '@cbgms/base/utils/datetime'
import { Grid, TextField } from '@mui/material'
import { Checkbox, TimePicker } from '@carsys/form'
import { useFormikContext } from 'formik'

interface IOuterProps {
  day: string
}

interface IMapStateToProps {
  durationUnits?: any
}

export const createDurationTime = (values: { [key: string]: string }, day: string) => {
  const active = values[`${day}Active`]
  const endTime = values[`${day}EndTime`]
  const startTime = values[`${day}StartTime`]

  const dayDurationTime = active ? moment.utc(moment(endTime, 'HH:mm').diff(moment(startTime, 'HH:mm'))).format('HH:mm') : '00:00'

  return moment.duration(dayDurationTime).asMinutes()
}

interface Props extends IOuterProps, IMapStateToProps {}

export const Day: React.FC<Props> = props => {
  const { day } = props
  const { values, errors } = useFormikContext<{ [key: string]: string }>()
  const active = values[`${props.day}Active`]
  const durationUnits = minutesToHours(createDurationTime(values, day))
  const { t } = useTranslation()

  return (
    <Grid data-testid='day-container' container columns={5} spacing={2} className='pb0'>
      <Grid item xs data-testid={`day-${day}`}>
        <Checkbox
          data-testid={`${day.toLowerCase()}-active-checkbox`}
          name={`${day}Active`}
          label={`${t(`setting_opening_hour.${day.toLowerCase()}`)}`}
        />
      </Grid>
      <Grid item xs>
        <TimePicker
          slotProps={{
            textField: {
              error: !!errors[`${day}StartTime`],
              fullWidth: true,
              placeholder: t('setting_opening_hour.select_time'),
              inputProps: {
                'data-testid': 'timepicker-start'
              }
            }
          }}
          minutesStep={5}
          name={`${day}StartTime`}
          disabled={!active}
        />
      </Grid>
      <Grid item xs>
        <TimePicker
          slotProps={{
            textField: {
              error: !!errors[`${day}EndTime`],
              fullWidth: true,
              placeholder: t('setting_opening_hour.select_time')
            }
          }}
          minutesStep={5}
          name={`${day}EndTime`}
          disabled={!active}
        />
      </Grid>
      {durationUnits && (
        <>
          <Grid item xs>
            <TextField
              fullWidth
              size='small'
              value={durationToMinutes(durationUnits)}
              inputProps={{ maxLength: 5, readOnly: true }}
              disabled={!active}
            />
          </Grid>
          <Grid item xs>
            <TextField fullWidth size='small' value={durationUnits} inputProps={{ maxLength: 5, readOnly: true }} disabled={!active} />
          </Grid>
        </>
      )}
    </Grid>
  )
}

Day.displayName = 'Day'

export default Day
